import React, { Component } from "react";
import Breadcrumbs from "../../shared/breadcrumbs/Breadcrumbs";
import "../Technical.css";

class canvasPluginIntegration extends Component {
  render() {
    const designerSetting =
      process.env.BASE_URL + "images/guides/designerSetting.png";
    const designerImplementation = process.env.BASE_URL + "images/guides/designerImplementation.png";
    const designerImplementationResponsiveContainer = process.env.BASE_URL + "images/guides/designerImplementationResponsiveContainer.png";
    return (
      <div className="technical-main">
        <Breadcrumbs />
        <div className="technical-content">
          <h1 className="main-heading">
            Canvas Plugin Implementation Guide for Designer Skin
          </h1>
          <h2 className="main-subheading">Overview</h2>
          <div className="technical-main-content">
            <p>
              Following modern web best practices, the Canvas Designer can be
              “plugged into” a your website. The designer is embedded within a
              your host page, allowing for more seamless and secure integration.
            </p>
            <p>
              The plugin does not require an iFrame to host the Canvas Designer,
              which allows for better branding control around the designer tool
              and mitigates possible security concerns in the future.
            </p>
            <p>
              It is now truly stateless and does not require a session to be
              able to hold information about the specific Canvas skin to be
              loaded, which also helps if setups require a proxy between the
              Canvas Designer and AAM Servers.
            </p>
            <p>
              The Framework used around the Canvas Designer Plugin allows for a
              fast single page designer application using concatenated and
              minified JavaScript and CSS files that can be easily embedded
              within any of your web pages.
            </p>
            <p>
              The term ‘Canvas’ refers to a new HTML5 technology that enhances
              the ability to manipulate images, providing greater possibilities
              for additional features and a more robust and consistent
              implementation.
            </p>
          </div>
          <h2 className="main-subheading">Features</h2>
          <div className="technical-main-content">
            <ul>
              <li>
                <p>Single page application (no page loads)</p>
              </li>
              <li>
                <p>Fully Stateless</p>
              </li>
              <li>
                <p>iFrame independent</p>
              </li>
              <li>
                <p>Seamless integration</p>
              </li>
              <li>
                <p>Better performance overall</p>
              </li>
              <li>
                <p>Responsive and customizable</p>
              </li>
              <li>
                <p>Advance state management</p>
              </li>
              <li>
                <p>Custom callbacks (changeView)</p>
              </li>
            </ul>
          </div>
          <h2 className="main-subheading">Browser Support</h2>

          <div className="technical-main-content">
            <p>
              {" "}
              Desktop Browser support for our Canvas designer application For
              the best experience using our applications, we recommend that you
              use the latest version of one of the following browsers:
            </p>
            <ul>
              <li>
                <p>Google Chrome</p>
              </li>
              <li>
                <p>Mozilla FireFox</p>
              </li>
              <li>
                <p>Microsoft Edge</p>
              </li>
              <li>
                <p>Safari</p>
              </li>
            </ul>

            <h3>Non-Supported Browsers</h3>
            <p>
              Internet Explorer 11 and below is no longer supported, as of 17th
              August 2021. We advise you to keep your browser updated so that
              you always use the latest version available, with the most recent
              bug fixes and security improvements. If you use a modern browser
              on a Managed Windows 10 Desktop or Managed Linux Desktop your
              browser will be updated automatically to the latest version
              available. If you use an older version of one of these browsers
              you might see web pages with a slightly different layout, but the
              content will be the same. The level of functionality in some
              applications may differ depending on the browser version you use.
            </p>

            <h3>Mobile/Tablet Devices </h3>
            <p>
              {" "}
              We recommend that you use the latest version of iOS or Android
              when using our applications on your mobile devices. If you have
              any specific questions or problems using our applications on your
              desktop, laptop or mobile device, please email with details of the
              application you’re using, your device, your browser (including
              version number), and your query.
            </p>
          </div>

          <h2 className="main-subheading">Demo</h2>
          <div className="technical-main-content">
            <p>
              A demo of the Canvas Plugin designer can be found using the
              following link which simulates a live integration:
            </p>
            <p>See the following links that simulate a live integration:</p>

            <h3>Basic html page</h3>
            <pre>
              https://uat.serversidegraphics.com/PCS/CDN/V3/App/clientDemo/demo/index.basic.html
            </pre>
            <p>Absolute minimum code to launch the designer.</p>

            <h3>Designer with responsive container</h3>
            <pre>
              https://uat.serversidegraphics.com/PCS/CDN/V3/App/clientDemo/demo/index.container.html
            </pre>
            <p>
              Basic designer implementation with styling applied to the host
              container.
            </p>

            <h3>Designer with custom</h3>
            <pre>
              https://uat.serversidegraphics.com/PCS/CDN/V3/App/clientDemo/demo/index.custom.html
            </pre>
            <p>
              As above, referring to same designer instance but with alternative
              styling. Open these links and use ‘View source’ to see a detailed
              implementation.
            </p>
          </div>
          <h2 className="main-subheading">Plugin Implementation</h2>
          <div className="technical-main-content">
            <p>
              A complete implementation requires the following components to be
              added to your host/index page:-
            </p>
            <li>
              <b>Designer placeholder: </b>
              <p>
                script containing a reference to the designer (embed.min.js)
                file.
              </p>
            </li>
            <li>
              <b>Designer container: </b>
              <p>
                your wrapper to determine the size and position of the designer
                in your host page’s layout.
              </p>
            </li>
            <li>
              <b>Designer source: </b>
              <p>A link to the designer (embed.min.js) file.</p>
            </li>
            <li>
              <b>Designer stylesheet :</b>
              <p>a link to the designer’s stylesheet (embed.min.css) file.</p>
            </li>
            <li>
              <b>Designer Parameter script:</b>
              <p>
                script containing configuration options for your designer
                implementation.
              </p>
            </li>
            <br />

            <h4>Designer placeholder</h4>
            <p>
              An AAM Product must be configured with access to a Canvas skin
              features enabled. This will create a unique GUID that must be
              added as the value for “data-handoverkey” as shown in red in the
              designer placeholder below:
            </p>
            <pre>
              &lt;div id=&quot;aam-designer&quot;
              class=&quot;aam-designer-init&quot;
              data-handoverkey=&quot;6e114ed0-d1f3-4010-a3e7-0470b3bf4642&quot;&gt;&lt;/div&gt;
            </pre>
            <p>
              This placeholder must reside in the Designer Container element
              (see below). The designer is programmed to fill this container
              (within specified limits) such that a responsive design experience
              can be achieved, displaying correctly over a range of sizes.
            </p>

            <h4>Designer Container</h4>
            <p>
              An element on your host-page will contain the Canvas Designer
              placeholder (below). The Designer Container can be placed
              alongside your own branding and other elements (if any) and its
              styling will be controlled by your own stylesheets. Your styling
              should therefore manage the Designer Container’s size across a
              range of screen sizes and devices to give the best responsive
              experience.{" "}
            </p>
            <p>
              <b>
                &ldquo;NB: This container element must have a value set for its
                height, e.g. height=100vh;&rdquo;
              </b>
            </p>
            <pre>
              &lt;div id=&quot;designerContainer&quot;
              class=&quot;my-container&quot;
              style=&quot;height:100vh&quot;&gt;&lt; div
              id=&quot;aam-designer&quot; class=&quot;aam-designer-init&quot;
              data-handoverkey=&quot;6e114ed0-d1f3-4010-a3e7-0470b3bf4642&quot;&gt;&lt;/div&quot;&gt;&lt;
              /div&gt;
            </pre>

            <h4>Designer (embed.min.js) Source</h4>
            <p>
              A script tag placed close to the closing &lt;body&gt; tag will
              contain a Url for the minified designer file (embed.min.js) on the
              appropriate server.
            </p>

            <pre>
              &lt;script type=&quot;text/javascript&quot;
              data-name=&quot;aam-designer&quot; data-bootstrap=&quot;true&quot;
              data-handoverkey=&quot;190b0a17-2443-440c-9af5-cdb2eeb30034&quot;
              src=&quot;https://uat.serversidegraphics.com/PCS/CDN/V3/App/Skins/CVS_GFirst/embed.min.js&quot;&gt;&lt;/script&gt;
            </pre>

            <h4>Designer Stylesheet</h4>
            <p>
              This file controls the styling applied to the Canvas Designer and
              exists alongside the embed.min.js file. The source link will
              typically refer to the file on our servers, but you may wish to
              refer to a customised version. ( see ‘Customising your designer’
              below).
            </p>
            <pre>
              &lt;link rel=&quot;stylesheet&quot;
              href=&quot;https://uat.serversidegraphics.com/PCS/CDN/V3/App/Skins/CVS_GFirst/embed.min.css&quot;&gt;&lt;/script&gt;
            </pre>

            <h4>Designer Parameters</h4>
            <p>
              A script containing various options for configuring your designer.
              For example:-
            </p>
            <pre>
              <img src={designerSetting}></img>
            </pre>
            <p>The script has two sections:</p>
            <ul>
              <li>
                <p>Callbacks</p>
              </li>
              <li>
                <p>Options</p>
              </li>
            </ul>

            <h4>Callbacks</h4>
            <ul>
              <li>
                <p>
                  <b>onLoad :</b>executes when the plugin has loaded (when API
                  is available)
                </p>
              </li>
              <li>
                <p>
                  <b>onSubmit : </b>executes when the user has submitted the
                  design (handback data is returned here).
                </p>
                <p>
                  Information about the design session can be accessed after the
                  onSubmit callback is fired using following:
                </p>
                <ul>
                  <li>
                    <p>
                      <b>“response.CardImageId” :</b>will return a unique AAM
                      CardImageId associated with the submitted design.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.Handover_Key” : </b>will return the product
                      HandoverKey.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.ImageType” :</b>will return the type of image
                      that an end user submitted during the design process.
                      These values can be “Gallery” or “Custom”
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.LanguageId” : </b>” will return the language
                      code that was used when displaying the designer. This can
                      be the default value setup in the AAM Product
                      configuration, or a language code passed into the
                      designer. Example codes “en-US”, “fr-FR”, etc.
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.emailaddress” :</b>will return the email
                      address of the end user that was captured
                    </p>
                  </li>
                </ul>
                <br/>
                <p><b>Using Custom Datacapture fields</b></p>
                <p>
                  Custom DataCapture fields can be setup within the AAM Product
                  Configuration page and can be accessed using the Name of the
                  DataCapture field setup.
                </p>
                <br/>
                <p>
                  For example, if you created a DataCapture field called
                  “customerName”, “address” and “PhoneNo”, you will be able to
                  use the following Keys to retrieve the submitted values in the
                  onSubmit() callback:
                </p>
                <ul>
                  <li>
                    <p>
                      <b>“response.customerName”</b>
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.address”</b>
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>“response.mobileNo”</b>
                    </p>
                  </li>
                </ul>

                <p>
                  <b>NB:</b>For onSubmit() to be executed, the handback
                  option (see below) must be set to enabled:false
                </p>
              </li>
              <li>
                <p>
                  <b>onError :</b>executes when an error has occurred (error
                  info is returned here).
                </p>
              </li>
            </ul>

            <h4>Options</h4>
            <p>
              <b>
                Please Note:</b> Any options used during the launch of the AAM HTML5
                Responsive Designer will override the default options already
                setup at Product level.
              
            </p>
            <ul>
              <li>
                <p>
                  <b>env: </b>: [required] can differentiate environment from
                  which designer is referenced (please get in touch with Thales
                  AAM team for specific values).
                </p>
              </li>
              <li>
                <p>
                  <b>emailAddress: </b>[optional] This allows for the email
                  address to be preset before loading the designer. This
                  emailAddress is always saved on the Thales database.
                </p>
                <p>
                  If email-capture is available (i.e. enabled in the Product
                  settings), the emailAddress prepopulates the email address
                  field of the email-capture page.
                </p>
              </li>
              <li>
                <p>
                  <b>lauguageId: </b>: [optional] Allows the Canvas Designer to
                  be loaded using a different language than the value setup by
                  default in the AAM Product configuration.
                </p>
              </li>
              <li>
                <p>
                  <b>detectMobile: </b> [optional] The Canvas Designer will
                  automatically check if it is being displayed on a touch screen
                  device. The Canvas Designer will append a ‘deviceMode’ class
                  to the &lt;body&gt; tag for touch-screen devices and
                  ‘desktopMode’ class otherwise. This allows you to specify
                  appropriate styling in each case as required. Set  <b>detectMobile:false</b> if you wish to turn this feature off.
                </p>
              </li>

              <li>
                <p>
                  <b>Passthrough: </b>: [optional] Parameters can be passed into
                  the designer session to be passed through to the Handback page
                  after design submission, for example:-
                </p>
                <pre>
                  passthrough: {"{"}customerName:&apos;John&apos;,
                  mobileNo:&apos;0123456789&apos;{"}"},
                </pre>
                <ul className="inner-list">
                  <li>
                    <p>
                    These can be potentially linked to DataCapture fields that have been setup within the AAM Product 
configuration.

                    </p>
                  </li>
                  <li>
                    <p>
                    In the example above, if no DataCapture field matches the CustomerName Key passed in, the key and 
value will be passed through to handback URL (see ‘Handback’ below).

                    </p>
                  </li>
                  <li>
                    <p>
                    The case (uppercase/lowercase) of the passthrough Keys and Values will be the same as that passed in 
the Options.
                    </p>
                  </li>
                  <li>
                    <p>
                    If DataCapture field keys match those of parameters passed in the Passthrough option:-
                    </p>
                    <ul className="inner-list">
                        <li>
                            <p>
                            The DataCapture fields will be pre-populated with the option values. If however, the matching 
DataCapture field is configured to be hidden in the AAM Product Configuration – the option 
value will still be stored as a DataCapture value.
                            </p>
                        </li>
                        <li>
                            <p>
                            DataCapture field “Pass out value on handback?“ value:-
                            </p>
                        <ul className="inner-list"><li><p>
                        True - Key/Value will be passed back with handback url
                            </p></li>
                            <li>
                                <p>False - Key/Value will not be passed back with handback url</p>
                            </li>
                            </ul>

                        </li>
                    </ul>
                  </li>
                  <p>In both cases, the DC Field value will be stored in the DC db</p>
                </ul>

              </li>

              <li>
                <p>
                  <b>Handback: </b> [optional] This is for dynamic handback URL functionality and has to be used in conjunction with 
the Dynamic Handback GUI which is setup at FI level in AAM Admin. If <b>Dynamic Handback GUI</b> is set at FI 
level, <b>Safe Handback URLs</b> section will be displayed within the AAM Product configuration.
                </p>
                <pre>
                handback: {"{"}URL:&apos;https://www.google.com?hello=hello&apos;{"}"},
                </pre>
                <br/>
                <p>The handback option has two properties:-</p>
                <ul className="inner-list">
                 
                  <li>
                    <p>
                      <b>url: </b> [required] A URL to redirect to on submission. This must match exactly a URL set in the ‘Safe 
Handback URLs’ section of the AAM Product configuration – including any qs parameters. 
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>enabled: </b> [optional] If set to ‘false’ the Canvas Designer will not redirect at the end of submission. 
This allows you to take advantage of the <b>Callback:onSubmit</b> function whereby you control the 
post-submit behaviour/messaging etc
                    </p>
                  </li>
                </ul>
                <p>If the handback option is not supplied, the designer will redirect to the default handback page set in the 
AAM Product Configuration.</p>
<p>
<b>NB:</b> If <b>Dynamic Handback GUI</b> is not enabled in the AAM ‘Edit Aggregator’ section, the handback 
option will be ignored. </p>
              </li>

              <li>
              <p><b>allowFullscreen: </b> [optional – only available for Gallery First designer skin] If set to true, the designer can be 
displayed at full-screen width and height, i.e. overriding the designer’s default maximum dimensions.</p>
<br/>
<p>Other options may be or become available depending on the chosen designer type.</p>
              </li>

              <li>
              <p><b>featureAreaColour: </b> [optional] Sets the coverage area border colour for all features. Defaults to red.</p>

              <pre>
              featureAreaColour: {"{"}#ffff00{"}"},
                </pre>
</li>
<li>
              <p><b>allowLockedFeatures: </b>  [optional – default false] If true, allows features (text, clipart etc) to be added to a 
locked gallery image.</p>
              </li>
            </ul>
          </div>


          <h2 className="main-subheading">
            Controlling the Plugin-designer dimensions
          </h2>
          <div className="technical-main-content">
            <p>
              The following meta-tags should be added to the &lt;head&gt; tag to
              optimize the responsive behaviour on mobile devices:-
            </p>
            <pre>
              &lt;meta name=&quot;viewport&quot;
              content=&quot;width=device-width, initial-scale=1&quot;&gt;
              <br />
              &lt;meta name=&quot;apple-mobile-web-app-capable&quot;
              content=&quot;yes&quot;&gt;
            </pre>
            <p>
            By default , the Canvas Designer is set up to fit its container element (as shown in red below) but with upper and lower 
limits. These depend on the Canvas Designer skin selected, but are approximately:-
            </p>
                    <ul className="inner-list">
                        <li>
                        <p><b>Mobile devices : </b></p>
                            <ul>
                                <li>min height: 320px&nbsp;&nbsp;&nbsp;max height: none </li>
                                <li>min-width: 320px&nbsp;&nbsp;&nbsp;max-width: none</li>
                            </ul>
                        </li>
                        
                        <li>
                        <p><b>Desktop devices : </b></p>
                        <ul>
                                <li>min height: 560px&nbsp;&nbsp;&nbsp;max height: 590px</li>
                                <li>min-width: 320px&nbsp;&nbsp;&nbsp;max-width: 1000px</li>
                            </ul>
                        </li>
                        
                        </ul>
                    <br/>
                    <br/>
                    <p><b>Do not apply your own CSS styling to the Canvas Designer placeholder </b>(i.e. the ‘aam-designer’ element).
</p>
            <pre>
              &lt;div id=&quot;designerContainer&quot;
              style=&quot;height:100vh&quot;&gt;&lt; div
              id=&quot;aam-designer&quot; class=&quot;aam-designer-init&quot;
              data-handoverkey=&quot;6e114ed0-d1f3-4010-a3e7-0470b3bf4642&quot;&gt;&lt;/div&quot;&gt;&lt;
              /div&gt;
            </pre>
            <br/>
            <p>The aim is to enable you to display your own branding and content alongside the designer where space allows. You 
must specify a height value for the container element.</p>
              <br />
              <p><b>For the best results, </b>the designer’s container should match these values, however if your host page does not contain 
your own elements, an alternative is to add ‘allowFullscreen:true’ to the options in appParams.js (see above). This will 
allow the designer to expand the size of the browser window for both mobile and desktop platforms.</p>
            
          </div>
          <h2 className="main-subheading">
            Language
          </h2>
          <div className="technical-main-content">
            <p>
            The designer uses text loaded from a central source at run-time, such that multiple languages can be used (see 
appParams options above). Languages can be specified on a per-product basis, but it is also possible to modify specific 
text elements e.g. button labels on a per-product basis.
            </p>
            </div>
            <h2 className="main-subheading">
            Sample HTML pages

          </h2>
          <div className="technical-main-content">
            <h4>
            Basic full-screen designer
            </h4>
            <br/>
            <pre>
            <img src={designerImplementation}></img>
            </pre>
            </div>
            <h2 className="main-subheading">Designer page with responsive container </h2>
          <br />

          <div className="technical-main-content">
          <pre>
            <img src={designerImplementationResponsiveContainer}></img>
            </pre>
          </div>
          <h2 className="main-subheading">Custom Styling </h2>
          <br />

          <div className="technical-main-content">
            <p>Some skins allow moderate visual customisation. To achieve this, a separate embed.min.css file will be created for your 
product and the its ‘href’ link adjusted accordingly:-
</p>
<pre>
              &lt;link rel=&quot;stylesheet&quot;
              href=&quot;yourProduct/embed.min.css&quot;&gt;&lt;/script&gt;
            </pre>
            </div>
        </div>
      </div>
    );
  }
}

export default canvasPluginIntegration;
